import actionTypes from "../action-types";
import { SessionXp } from "../models/SessionXp";

export type UpdateSessionXpPayload = {
  sessionId: string;
  xp: SessionXp;
};

export default function updateSessionXp(payload: UpdateSessionXpPayload) {
  return {
    type: actionTypes.UPDATE_SESSION_XP,
    payload
  };
}
